import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class WarningModal extends React.Component {
  static propTypes = {
    item: PropTypes.object,
    hideModal: PropTypes.func
  }
  componentDidMount() {}
  render() {
    const { item } = this.props
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={this.handleDelete}
        maxWidth={'xs'}
        title={`Attention`}
        cancelText="Fermer"
        showOk={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              Vous ne pouvez pas effectué cette action car "{item.name}" est
              actuellement utilisé ailleurs.
            </Typography>
            <Typography variant="caption" gutterBottom>
              Réessayez plus tard
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(WarningModal)



// WEBPACK FOOTER //
// ./src/components/modals/common/WarningModal.js